// Paletas precargadas de "Prisma" (eventos formales).
const FUENTES = {
  display: '"Libre Franklin", system-ui, sans-serif',
  cuerpo: '"Source Sans 3", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "corporativo",
    nombre: "Corporativo",
    tema: {
      colores: {
        fondo: "#F7F9FC",
        fondoAlt: "#EDF1F7",
        texto: "#182233",
        textoSuave: "#4A5568",
        textoTenue: "#8A94A6",
        primario: "#1D4E89",
        primarioSuave: "#DCE7F3",
        acento: "#E8A33D",
        borde: "rgba(24, 34, 51, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "burdeos",
    nombre: "Burdeos",
    tema: {
      colores: {
        fondo: "#FBF7F7",
        fondoAlt: "#F4EBEB",
        texto: "#2C1B20",
        textoSuave: "#5E434C",
        textoTenue: "#9A8189",
        primario: "#7A2E3F",
        primarioSuave: "#F0DEE2",
        acento: "#C9A227",
        borde: "rgba(44, 27, 32, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "bosque",
    nombre: "Bosque",
    tema: {
      colores: {
        fondo: "#F5F9F6",
        fondoAlt: "#E9F1EB",
        texto: "#182B23",
        textoSuave: "#46594F",
        textoTenue: "#84988D",
        primario: "#235C4B",
        primarioSuave: "#DCEAE3",
        acento: "#D97706",
        borde: "rgba(24, 43, 35, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
];
